import { escapeHtml, safeUrl } from '../escape.js';
import { editAttr, itemCollection, itemStr, labeledIntro, list, sectionOpen, str } from './helpers.js';
import type { PatternSectionT } from '../../schema/index.js';

function initials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  const first = words[0]?.charAt(0) ?? '';
  let last = '';
  if (words.length > 1) last = words.at(-1)?.charAt(0) ?? '';
  return `${first}${last}`;
}

/** team — member cards with portraits or initials monograms. */
export function renderTeam(section: PatternSectionT): string {
  const heading = str(section.fields, 'heading');
  const label = str(section.fields, 'label');
  const members = list(section.fields, 'members')
    .map((item, index) => {
      const name = itemStr(item, 'name');
      const role = itemStr(item, 'role');
      const bio = itemStr(item, 'bio');
      const imageUrl = itemStr(item, 'image_url');
      const alt = itemStr(item, 'alt') || itemStr(item, 'image_alt') || name;
      if (!name && !role && !bio && !imageUrl) return '';
      const memberPath = `/members/${index}`;
      const lines = [`    <article class="ve-team__member"${editAttr(section, memberPath)}>`];
      if (imageUrl) {
        const imagePath = `/members/${index}/image_url`;
        lines.push(`      <img class="ve-team__image" src="${safeUrl(imageUrl)}" alt="${escapeHtml(alt)}"${editAttr(section, imagePath)}>`);
      } else if (name) {
        lines.push(`      <span class="ve-team__monogram" aria-hidden="true">${escapeHtml(initials(name))}</span>`);
      }
      if (name) lines.push(`      <h3 class="ve-team__name">${escapeHtml(name)}</h3>`);
      if (role) lines.push(`      <p class="ve-team__role">${escapeHtml(role)}</p>`);
      if (bio) lines.push(`      <p class="ve-team__bio">${escapeHtml(bio)}</p>`);
      lines.push('    </article>');
      return lines.join('\n');
    })
    .filter(Boolean)
    .join('\n');

  const parts: string[] = [
    sectionOpen(section),
    ...labeledIntro(section, 'team', heading, label),
    itemCollection(section, 'div', 've-team__members', '/members', members),
    '</section>',
  ];
  return parts.join('\n');
}
